var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_007-cube",
    "data-name": "007-cube",
    transform: "translate(-38 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M94,123.968c0-.019,0-.038,0-.057a2,2,0,0,0-1.051-1.7l-7.4-3.987a2,2,0,1,0-1.9,3.522L88,124.084,66,137.621,44,124.084,48.4,121.72a2,2,0,0,0-1.9-3.522l-7.447,4.01a2,2,0,0,0-1.051,1.7c0,.02,0,.038,0,.057h0v15a2,2,0,0,0,.906,1.674l26,17,0,0c.046.03.091.062.14.089a2,2,0,0,0,2.046-.085l26-17A2,2,0,0,0,94,138.968v-15h0Zm-52,3.58,22,13.538v11.185L42,137.887Zm26,24.723V141.087l22-13.539v10.339Z",
    transform: "translate(0 -71.968)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M108.972,32.252l-18-10a2,2,0,0,0-1.943,0l-18,10A2,2,0,0,0,70,34V49a2,2,0,0,0,.957,1.707l18,11a2,2,0,0,0,2.021.038c.022-.012.041-.028.063-.041l0,0,18-11A2,2,0,0,0,110,49V34a2,2,0,0,0-1.029-1.748ZM90,26.288,103.882,34,90,41.713,76.118,34ZM74,47.879V37.4l14,7.778V56.434Zm18,8.556V45.177L106,37.4v10.48Z",
    transform: "translate(-24 0)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVision);
export default __webpack_public_path__ + "static/media/our_vision.9c261263f023a016e3baf8033ec9df50.svg";
export { ForwardRef as ReactComponent };